<template>
  <v-container
    fluid
    grid-list-lg
  >
    <v-toolbar
      height="65"
      app
      center
      class="baner"
    >
      <v-spacer />
      <v-avatar
        :title="title"
        size="60px"
      >
        <v-img :src="require('@/assets/uniq.png')" />
      </v-avatar>

      <h2 class="center">
        UNIVERSIDAD NACIONAL INTERCULTURAL DE QUILLABAMBA
      </h2>

      <v-spacer />
    </v-toolbar>
    <template>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          sm12
          md12
        >
          <v-card>
            <v-layout
              align-center
              justify-center
              row
              fill-height
            >
              <v-card-title primary-title>
                <span
                  class="success--text font-weight-bold headline align-center justify-center"
                />VERIFICAR INSCRIPCIÓN
              </v-card-title>
            </v-layout>
            <center>
              <v-flex
                xs12
                sm12
                md6
              >
                <form>
                  <v-text-field
                    v-model="dni"
                    label="DNI"
                    required
                    outline
                  />
                  <v-text-field
                    v-model="legal_representative"
                    label="Apoderado"
                    required
                    outline
                  />
                  <v-autocomplete
                    v-model="type_exam_id"
                    :items="typeexams"
                    :loading="loadingTypeexams"
                    dense
                    clearable
                    small-chips
                    label="SELECCIONAR MODALIDAD DE EXAMEN"
                    item-text="title"
                    item-value="id"
                    required
                    outline
                  />
                  <v-btn
                    color="success"
                    @click="_verify"
                  >
                    VERIFICAR
                  </v-btn>
                </form>

                <br>
                <v-textarea
                  v-if="observation != '' && observation != null"
                  v-model="observation"
                  label="observacion"
                  readonly
                  required
                  outline
                />

                <br>
                <a
                  v-if="ficha != '' && ficha != null"
                  style="text-decoration:none;"
                  :href="ficha"
                  target="_blank"
                >
                  <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                  >
                    DECARGAR FICHA
                    <v-icon
                      right
                      dark
                    >cloud_download</v-icon>
                  </v-btn>
                </a>
                <br>
                <v-btn @click="$router.go(-1)">
                  SALIR
                </v-btn>
              </v-flex>
            </center>
          </v-card>
          <v-divider />
          <br>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      dni: '',
      legal_representative: '',
      type_exam_id: '',
      ficha: '',
      observation: '',
      title: 'Verificación de inscripción'
    }
  },
  computed: {
    ...mapState({
      typeexams: state => state.typeExams.typeexams,
      loadingTypeexams: state => state.typeExams.loadingTypeexams
    })
  },
  mounted () {
    this.getExams()
  },
  methods: {
    ...mapActions({
      getVerifyInscription: 'admision/getVerifyInscription',
      getExams: 'typeExams/getExams'
    }),
    async _verify () {
      try {
        if (
          !this.dni || !this.type_exam_id
        ) {
          this.$message({
            showClose: true,
            message: 'Ingresar los datos',
            type: 'error'
          })
          return
        }
        const res = await this.getVerifyInscription({
          dni: this.dni,
          reprensentative: this.legal_representative,
          type_exam_id: this.type_exam_id
        })
        this.observation = res.data.data.observation
        this.ficha = res.data.data.format_path
      } catch (error) {
        this.$message.error('Error al verificar')
      }
    }
  }
}
</script>
<style scoped>
.scoped-toolbar-title {
  display: flex;
  filter: opacity(70%);
  align-items: center;
  padding-right: 1.4rem;
}
.center {
  display: flex;
  align-items: center;
  padding-right: 1.4rem;
  font-size: 25px;
  margin-inline-start: 20px;
}
.baner {
  background-color: teal;
  color: aliceblue;
}
@media only screen and (max-width: 600px) {
  .center {
    display: flex;
    align-items: center;
    padding-right: 0.5em;
    font-size: 14px;
    margin-inline-start: 20px;
  }
}
</style>
